<template>
	<div :class="{ 'can-close': canClose }" class="alert">
		<!--
			Someone should figure this out. It was the one line that was holding
			up the linting of the om-js-library, so I didn't want to waste time
			trying to figure it out. Ideally, we don't have this exception.
			See https://eslint.vuejs.org/rules/require-component-is.html
		-->
		<!-- eslint-disable-next-line vue/require-component-is -->
		<component v-if="icon" v-bind:is="icon" class="alert-icon" />
		<slot />
		<div v-if="canClose" @click="startCloseAlert" class="close-alert">
			<button @click="startCloseAlert" type="button" class="unbutton">
				<svg-times />
			</button>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
import { alerts } from '../../mixins/alerts';
export default {
	mixins: [alerts],
	props: {
		close: {
			type: Boolean,
			default() {
				return false;
			},
		},
		closes: {
			type: [String, Boolean],
			default() {
				return false;
			},
		},
		index: {
			type: Number,
			default: 0,
		},
		icon: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			closing: false,
		};
	},
	computed: {
		canClose() {
			return this.close || this.closes;
		},
	},
	methods: {
		...mapMutations(['closeAlert']),
		startCloseAlert() {
			if (!this.closing) {
				// Check if we need to set a cookie so this alert won't open again.
				if (this.closes && true !== this.closes) {
					this.addClosedAlert(this.closes);
				}

				this.closing = true;
				this.closeAlert(this.index);
			}

			setTimeout(() => {
				this.closing = false;
			}, 0);
		},
	},
};
</script>
<style lange="scsss" scoped>
.close-alert * {
	cursor: pointer;
}
</style>
